const MODAL_ID = 'kpn-popup-overlay';

// Mediathek-Einträge: /mediathek/<slug> (DE) und /en/media/<slug> (EN).
// Die Übersichtsseiten (/mediathek, /en/media) sollen NICHT im Popup landen,
// deshalb ist ein Slug-Segment verpflichtend.
const MEDIATHEK_PATH = /^(?:\/[a-z]{2})?\/(?:mediathek|media)\/[^/]+/;

// Redaktionelles Override: Klasse `popup` am Link im CKEditor
// (Feld-Einstellung „Klassenname" / advancedLinkFields).
const MANUAL_CLASS = 'popup';

/**
 * Ermittelt die URL, die ein Klick im Popup öffnen soll — oder null.
 * Neben den expliziten Triggern (data-popup) greifen jetzt auch
 * Text-Links auf Mediathek-Einträge und `a.popup`.
 */
function resolveTriggerHref(e) {
  if (e.defaultPrevented) return null;
  // Modifier-/Mittelklicks weiterhin dem Browser überlassen (neuer Tab etc.)
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;

  const explicit = e.target.closest('[data-popup="true"]');
  if (explicit) return explicit.dataset.popupHref || null;

  const link = e.target.closest('a[href]');
  if (!link) return null;
  // „In neuem Tab öffnen" im Link-Dialog schlägt das Popup
  if (link.target && link.target !== '_self') return null;
  if (link.origin !== window.location.origin) return null;
  if (!link.classList.contains(MANUAL_CLASS) && !MEDIATHEK_PATH.test(link.pathname)) return null;

  return link.href;
}

// Hängt popup=1 an, ohne bestehende Query-Parameter/Anker zu zerstören
function popupHref(href) {
  const url = new URL(href, window.location.href);
  url.searchParams.set('popup', '1');
  return url.toString();
}

function initPopup() {
  // Inside an iframe (e.g. production page loaded in the outer popup):
  // Don't create a nested popup — forward trigger clicks to the parent via postMessage.
  if (window.self !== window.top) {
    document.addEventListener('click', (e) => {
      const href = resolveTriggerHref(e);
      if (!href) return;
      e.preventDefault();
      window.parent.postMessage({ type: 'kpn-navigate', href: popupHref(href) }, window.location.origin);
    });
    return;
  }

  // Outer page: create the single shared popup overlay
  const modalBody = document.createElement('kpn-modal-body');
  modalBody.setAttribute('modalId', MODAL_ID);
  // 'dialog' = zentriertes Popup (Seite bleibt an den Rändern sichtbar).
  // Bewusst NICHT 'full' — 'full' bleibt für Menü/Suche das randlose Vollbild.
  modalBody.setAttribute('size', 'dialog');
  modalBody.setAttribute('state', 'close');
  modalBody.setAttribute('background', 'white');
  modalBody.setAttribute('color', 'black');
  modalBody.setAttribute('close-style', 'center');

  const iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'width:100%;height:100%;border:none;');
  iframe.setAttribute('title', 'Popup');
  modalBody.appendChild(iframe);

  document.body.appendChild(modalBody);

  // Tracks the URL to go back to (set when the iframe navigates deeper)
  let previousSrc = '';

  // Receive navigation requests from within the iframe
  window.addEventListener('message', (e) => {
    if (e.origin !== window.location.origin) return;
    if (!e.data || e.data.type !== 'kpn-navigate') return;
    previousSrc = iframe.src;
    iframe.src = e.data.href;
    // Modal is already open — just swap the content
  });

  // Handle direct popup triggers on the outer page
  document.addEventListener('click', (e) => {
    const href = resolveTriggerHref(e);
    if (!href) return;
    e.preventDefault();
    previousSrc = '';
    iframe.src = popupHref(href);
    window.dispatchEvent(new CustomEvent(`modal-open-${MODAL_ID}`));
  });

  // Close: if we navigated deeper (mediathek inside production popup),
  // go back to the previous page instead of closing.
  // handleClose() sets iframe.src='about:blank' before firing this event —
  // overriding it here causes the browser to process only the final assignment.
  window.addEventListener(`modal-close-${MODAL_ID}`, () => {
    if (previousSrc) {
      const src = previousSrc;
      previousSrc = '';
      iframe.src = src; // override the about:blank set by handleClose
      window.dispatchEvent(new CustomEvent(`modal-open-${MODAL_ID}`)); // stay open
    }
    // No previousSrc → normal close, iframe stays blank
  });
}

export default initPopup;
